import { RECEIVE_RESET_PASSWORD, CLEAR_PASSWORD_RESET } from '../constants/ActionTypes';

const forgotStatus = (state = null, action) => {
  switch (action.type) {
    case RECEIVE_RESET_PASSWORD:
      return action.resetPasswordStatus
    case CLEAR_PASSWORD_RESET:
      return null;
    default:
      return state;
  }
}

export default forgotStatus;



// WEBPACK FOOTER //
// ./src/reducers/forgotStatus.js